import { useTranslation } from 'react-i18next'

import clsx from 'clsx'
import { observer } from 'mobx-react-lite'

import { TicketWithNoTariff } from 'pages/avia/detail-ticket/components/ticket-tariff'

import { isDifficultAviaRoute } from 'entities/ticket/lib/is-difficult-avia-route'
import findTicketStore from 'entities/ticket/models/find-ticket/find-ticket-store'
import listTicketsStore from 'entities/ticket/models/list-tickets/list-tickets-store'
import TarrifPop from 'entities/ticket/ui/tarrif-pop'
import { TicketDirectionDetails } from 'entities/ticket/ui/ticket-direction-details'

import { prepareDetailTicketInfo } from 'shared/lib/ticketRender'
import { useDialogBottomSheet } from 'shared/ui/dialog-bottom-sheet/lib'
import { FlightDetailsPopup } from 'shared/ui/flight-details-poup'

import HeaderPurchase from '../../components/Header'

import s from './styles.module.scss'

export const CheckPage = observer(() => {
  const { t } = useTranslation()

  const { openDialog } = useDialogBottomSheet()

  const ticket = listTicketsStore.getSelectedTicket()

  const countPassengerInfo = findTicketStore.getCountOfPassengers()

  if (!ticket) return null

  const detailTicket = prepareDetailTicketInfo(ticket)
  const isDifficultRoute = isDifficultAviaRoute(
    findTicketStore.formFindTicket.directions,
  )

  const onDetailBaggage = (directionIndex: number, segmentNum: number) => {
    const segment =
      detailTicket?.resultsAllListDirections?.[directionIndex]?.[segmentNum]

    openDialog({
      child: (
        <FlightDetailsPopup
          flightCode={`${t('flight')} ${segment?.carrier.code}-${
            segment?.flight_number
          }`}
          timeFlight={`${segment?.dep?.time || ''}`}
          airplane={segment?.aircraft?.title || ''}
          baggage={segment?.baggage}
          cBaggage={segment?.cbaggage}
        />
      ),
    })
  }

  const onShowTariff = () => {
    openDialog({
      child: <TarrifPop rulesParams={ticket} />,
    })
  }

  return (
    <div className={clsx('container', s.container)}>
      <div className={s.header}>
        <HeaderPurchase
          title={t('detail_flight')}
          variant="grey"
        />
      </div>

      {detailTicket?.detailTicketInfo &&
        detailTicket?.resultsAllListDirections && (
          <TicketDirectionDetails
            detailTicketInfo={detailTicket.detailTicketInfo}
            resultsAllListDirections={detailTicket.resultsAllListDirections}
            isDifficultRoute={isDifficultRoute}
            getDirectionKey={(group) => group.title}
            onDetail={onDetailBaggage}
          />
        )}

      <TicketWithNoTariff
        isCheckPage
        ticket={ticket}
        onShowTariffInfo={onShowTariff}
        passengerCount={countPassengerInfo}
      />
    </div>
  )
})
